export default __webpack_public_path__ + "static/laptop-f1f50c3e235a7d4a249d89b61c22fe9a.png";